export default "/fonts/hotelspace.svg?a3efca80d8f9bfe18cd99144c43e2524";